// Blog-Detail: Auto-Nummerierung H2 + TOC-Aside + Reading-Dock (Progress + Active-Chapter-Label)
export default function initBlogDetail() {
  const article = document.querySelector('.blog-post-content__body, .article');
  if (!article) return;

  if (!article.id) article.id = 'post-body';

  // === 1. Lesezeit ===
  const text = article.textContent || '';
  const words = text.trim().split(/\s+/).filter(Boolean).length;
  const minutes = Math.max(1, Math.round(words / 220));
  document.querySelectorAll('[data-reading-time]').forEach(el => { el.textContent = `${minutes} min Lesezeit`; });
  document.querySelectorAll('[data-reading-time-min]').forEach(el => { el.textContent = String(minutes); });

  // === 2. Freshness ===
  document.querySelectorAll('[data-freshness]').forEach(el => {
    const iso = el.dataset.date;
    if (!iso) return;
    const diffDays = (Date.now() - new Date(iso).getTime()) / 86400000;
    let label, dotColor;
    if (diffDays < 90)       { label = 'aktuell';  dotColor = 'var(--color-brand)'; }
    else if (diffDays < 180) { label = 'neu';      dotColor = 'var(--color-brand)'; }
    else if (diffDays < 365) { label = 'älter';    dotColor = 'var(--color-warm, #FFB347)'; }
    else                     { label = 'archiv';   dotColor = 'var(--color-text-muted)'; }

    const dot = el.querySelector('.pulse-dot');
    const labelEl = el.querySelector('[data-freshness-label]');
    if (dot) dot.style.background = dotColor;
    if (labelEl) labelEl.textContent = label;
  });

  // === 3. H2-Nummerierung + Slug-IDs ===
  const h2s = Array.from(article.querySelectorAll('h2'));
  h2s.forEach((h, i) => {
    const n = String(i + 1).padStart(2, '0');
    h.setAttribute('data-n', n);
    if (!h.id) {
      const slug = (h.textContent || '')
        .toLowerCase()
        .replace(/[^\p{Letter}\p{Number}\s-]/gu, '')
        .trim()
        .replace(/\s+/g, '-')
        .substring(0, 60);
      if (slug) h.id = slug;
    }
  });

  // === 4. TOC-Aside aufbauen ===
  const tocHost = document.getElementById('toc-auto');
  let tocLinks = [];
  if (tocHost && h2s.length) {
    const ol = document.createElement('ol');
    ol.className = 'toc-list';
    h2s.forEach((h, i) => {
      if (!h.id) return;
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = '#' + h.id;
      a.dataset.tocTarget = h.id;
      const nSpan = document.createElement('span');
      nSpan.className = 'n';
      nSpan.textContent = String(i + 1).padStart(2, '0');
      a.appendChild(nSpan);
      a.appendChild(document.createTextNode(h.textContent.trim()));
      li.appendChild(a);
      ol.appendChild(li);
    });
    tocHost.appendChild(ol);
    tocLinks = Array.from(ol.querySelectorAll('a'));
  }

  // === 5. Reading-Dock: Menu befüllen (Clone der TOC) ===
  const dock = document.querySelector('[data-reading-dock]');
  const dockMenu = document.querySelector('[data-reading-menu]');
  let dockLinks = [];
  if (dock && dockMenu && h2s.length) {
    const ol = document.createElement('ol');
    h2s.forEach((h, i) => {
      if (!h.id) return;
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = '#' + h.id;
      a.dataset.tocTarget = h.id;
      const n = document.createElement('span');
      n.className = 'n';
      n.textContent = String(i + 1).padStart(2, '0');
      a.appendChild(n);
      a.appendChild(document.createTextNode(h.textContent.trim()));
      li.appendChild(a);
      ol.appendChild(li);
    });
    dockMenu.appendChild(ol);
    dockLinks = Array.from(dockMenu.querySelectorAll('a'));
  }

  // === 6. Scroll-Spy: Active-State für TOC + Dock-Label ===
  const dockNum = document.querySelector('[data-reading-label] .reading-dock-num');
  const dockTitle = document.querySelector('[data-reading-label] .reading-dock-title');

  function setActive(id) {
    tocLinks.forEach(l => l.classList.toggle('active', l.dataset.tocTarget === id));
    dockLinks.forEach(l => l.classList.toggle('active', l.dataset.tocTarget === id));
    const h = document.getElementById(id);
    if (h && dockNum && dockTitle) {
      const n = h.getAttribute('data-n') || '';
      dockNum.textContent = n ? `// ${n}` : '';
      dockTitle.textContent = h.textContent.trim();
    }
  }

  const observer = new IntersectionObserver(entries => {
    const visible = entries
      .filter(e => e.isIntersecting)
      .sort((a, b) => a.target.getBoundingClientRect().top - b.target.getBoundingClientRect().top);
    if (visible.length) setActive(visible[0].target.id);
  }, { rootMargin: '-120px 0px -65% 0px', threshold: 0 });

  h2s.forEach(h => { if (h.id) observer.observe(h); });

  // === 7. Dock sichtbar nach Scroll > 300px, Progress-Bar ===
  if (dock) {
    const progressEl = document.querySelector('[data-reading-progress]');
    let ticking = false;

    function updateDock() {
      const scrollY = window.scrollY;
      const artRect = article.getBoundingClientRect();
      const artTop = scrollY + artRect.top;
      const artHeight = article.offsetHeight;

      // Sichtbar wenn Artikel-Oberkante >100px über Viewport-Top
      const show = scrollY > artTop - 100 && scrollY < artTop + artHeight;
      dock.toggleAttribute('hidden', !show);
      dock.setAttribute('data-visible', show ? 'true' : 'false');

      // Progress in % über Artikel
      const progressed = Math.max(0, Math.min(1, (scrollY - artTop + window.innerHeight * 0.3) / artHeight));
      if (progressEl) progressEl.style.setProperty('--progress', (progressed * 100).toFixed(1) + '%');

      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(updateDock); ticking = true; }
    }, { passive: true });
    window.addEventListener('resize', updateDock, { passive: true });
    updateDock();
  }

  // === 8. Dock-Menu Toggle ===
  const dockToggle = document.querySelector('[data-reading-toggle]');
  if (dockToggle && dockMenu) {
    dockToggle.addEventListener('click', () => {
      const open = dockToggle.getAttribute('aria-expanded') === 'true';
      dockToggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      dockMenu.toggleAttribute('hidden', open);
    });
    // Close on click outside
    document.addEventListener('click', e => {
      if (!dock.contains(e.target)) {
        dockToggle.setAttribute('aria-expanded', 'false');
        dockMenu.setAttribute('hidden', '');
      }
    });
    // Close on menu-link click + smooth scroll
    dockLinks.forEach(l => {
      l.addEventListener('click', () => {
        dockToggle.setAttribute('aria-expanded', 'false');
        dockMenu.setAttribute('hidden', '');
      });
    });
    // Esc schließt
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && dockToggle.getAttribute('aria-expanded') === 'true') {
        dockToggle.setAttribute('aria-expanded', 'false');
        dockMenu.setAttribute('hidden', '');
        dockToggle.focus();
      }
    });
  }
}
